import React from "react";
import { DestinationTypeLabels } from "../../../models/destinationType.map";
import { buttonPrimary, buttonSecondary } from "../styles/suiviLivraisonStyles";

// Confirmation avant de renvoyer un produit livré dans son onglet de production.
export function RetraitementConfirmModal({ row, onConfirm, onCancel }) {
    const patient = [row.patientPrenom, row.patientNom].filter(Boolean).join(" ") || "Patient non renseigné";
    const destination = DestinationTypeLabels[row.destination] || row.destination || "Destination inconnue";

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 1100,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
                backdropFilter: "blur(2px)",
            }}
        >
            <button type="button" aria-label="Annuler le retraitement" onClick={onCancel} style={{ position: "absolute", inset: 0, border: 0, background: "rgba(15, 23, 42, 0.45)" }} />
            <dialog
                open
                aria-labelledby="retraitement-title"
                onKeyDown={event => { if (event.key === "Escape") onCancel(); }}
                style={{
                    position: "relative",
                    margin: 0,
                    padding: 0,
                    width: "100%",
                    maxWidth: "440px",
                    overflow: "hidden",
                    border: "1px solid #e2e8f0",
                    borderRadius: "14px",
                    background: "white",
                    boxShadow: "0 24px 70px rgba(15, 23, 42, 0.22)",
                }}
            >
                <div style={{ display: "flex", gap: "12px", padding: "20px 22px 14px" }}>
                    <div style={{
                        width: "40px",
                        height: "40px",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "10px",
                        background: "#eff6ff",
                        color: "#2563eb",
                        fontSize: "20px",
                    }}>
                        ↩
                    </div>
                    <div>
                        <h3 id="retraitement-title" style={{ margin: "1px 0 4px", color: "#0f172a", fontSize: "17px" }}>
                            Renvoyer le produit ?
                        </h3>
                        <p style={{ margin: 0, color: "#64748b", fontSize: "13px", lineHeight: 1.5 }}>
                            Le produit retournera dans l’onglet de production indiqué.
                        </p>
                    </div>
                </div>

                <div style={{ margin: "0 22px", padding: "14px 16px", border: "1px solid #e2e8f0", borderRadius: "10px", background: "#f8fafc" }}>
                    <ModalDetail label="Produit" value={[row.nom, row.dosage].filter(Boolean).join(" ") || "Non renseigné"} />
                    <ModalDetail label="Patient" value={patient} />
                    <ModalDetail label="Destination" value={destination} last />
                </div>

                <div style={{ margin: "14px 22px 0", padding: "10px 12px", borderRadius: "8px", background: "#fff7ed", color: "#9a3412", fontSize: "12px", lineHeight: 1.45 }}>
                    La validation de mise en caisse sera annulée. Les informations de facturation seront conservées.
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", padding: "18px 22px 20px" }}>
                    <button type="button" onClick={onCancel} style={{ ...buttonSecondary, padding: "8px 14px" }}>
                        Annuler
                    </button>
                    <button type="button" onClick={onConfirm} style={{ ...buttonPrimary, padding: "8px 14px", background: "#2563eb", borderColor: "#2563eb", color: "white" }}>
                        Confirmer le renvoi
                    </button>
                </div>
            </dialog>
        </div>
    );
}

function ModalDetail({ label, value, last = false }) {
    return (
        <div style={{ display: "flex", justifyContent: "space-between", gap: "16px", padding: "6px 0", borderBottom: last ? "none" : "1px solid #e2e8f0" }}>
            <span style={{ color: "#94a3b8", fontSize: "12px", fontWeight: 600 }}>{label}</span>
            <span style={{ color: "#334155", fontSize: "12px", fontWeight: 700, textAlign: "right" }}>{value}</span>
        </div>
    );
}
